<template>
<div class="v-input-file"
  :class="{ disabled }">

  <div class="v-input-file__label"
    v-if="label">
    {{ label }}
  </div>

  <label v-if="!file?.size">
    <input class="v-input-file__input"
      type="file"
      v-bind="{ accept, disabled }"
      @change="inputFile($event)">
    <slot>
      <div class="v-input-file__body"
        :style="{ color: $cmain }">
        <v-icon class="v-input-file__icon">
          attach_file
        </v-icon>
        <span class="v-input-file__text">
          {{ labelUpload ?? $ct('v_input_file.upload_file') }}
        </span>
      </div>
    </slot>
  </label>

  <div class="text-error"
    v-if="v$.file.$error">
    {{ $ct('v_input_file.file_required') }}
  </div>

  <div class="v-input-file__body"
    v-if="file?.size">
    {{ file.name }}
    <v-icon class="v-input-file__icon" outlinedstyle="color:red"
      @click="file=null">delete</v-icon>
    <span class="v-input-file__spinner"
      v-loading.small="uploadURL && isUploading">
    </span>
  </div>

</div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { requiredIf } from '@vuelidate/validators'
export default {
  emits: [
    'change',
    'uploading',
    'uploaded',
  ],
  props: {
    required: { type: Boolean, required: false, default: false },
    accept: { type: String, required: false, default: '*' },
    disabled: { type: Boolean, required: false, default: false },
    maxSize: { type: Number, required: false, default: 250 },
    fileName: { type: String, required: false, default: undefined },
    uploadURL: { type: String, required: false, default: undefined },
    formFields: { type: Object, required: false, default: undefined },
    label: { type: String, required: false, default: undefined },
    labelUpload: { type: String, required: false, default: undefined },
    labelDelete: { type: String, required: false, default: undefined },
  },
  data() {
    return {
      v$: useVuelidate(),
      isUploading: false,
      file: null,
    }
  },
  validations() {
    return {
      file: {
        name: { required: requiredIf(_ => this.required) }
      },
    }
  },
  methods: {
    click() {
      this.$refs.input.click()
    },
    async inputFile(event) {
      this.isSavePossible = true
      this.file = event.target.files[0]
      if (this.file == '') return
      if (this.file.size > this.maxSize*1024*1024) return this.$popupError(this.$ct('v_input_file.file_size_error') + ' ' + this.maxSize + ' ' + this.$ct('v_input_file.mb'))
      this.$emit('change', this.file)
      if (this.uploadURL) {
        await this.uploadFile()
      }
    },
    async uploadFile() {
      this.isUploading = true
      this.model = this.formFields
      this.model.file = this.file
      const { data } = await this.$api.postForm(this.uploadURL, this.model)
      this.$emit('uploaded', data)
      this.isUploading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.v-input-file {
  &__label {
    margin-bottom: .75em;
    line-height: 1.5;
    color: #0008;
  }
  &__input {
    display: none;
  }
  &__body {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: .5em;
    &:hover { opacity: .75; }
  }
  &__icon {
    font-size: 1.25em;
    font-weight: normal;
    vertical-align: middle;
  }
  &__text {
    vertical-align: middle;
  }
  &__error {
    margin-top: .5em;
    font-size: .85em;
    font-weight: 500;
    color: $red;
  }
  &__spinner {
    display: inline-block;
    width: 2em;
  }
}
</style>
